import { render } from "./CguPage.vue?vue&type=template&id=3efa55c7&scoped=true&ts=true"
import script from "./CguPage.vue?vue&type=script&lang=ts"
export * from "./CguPage.vue?vue&type=script&lang=ts"

import "./CguPage.vue?vue&type=style&index=0&id=3efa55c7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efa55c7"]])

export default __exports__